import { render, staticRenderFns } from "./FDYSystem.vue?vue&type=template&id=86746ffe&scoped=true"
import script from "./FDYSystem.vue?vue&type=script&lang=js"
export * from "./FDYSystem.vue?vue&type=script&lang=js"
import style0 from "./FDYSystem.vue?vue&type=style&index=0&id=86746ffe&prod&lang=scss"
import style1 from "./FDYSystem.vue?vue&type=style&index=1&id=86746ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86746ffe",
  null
  
)

export default component.exports